import React, { Component, useState } from "react";
import Table from "../../../utilities/table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Modal } from "react-bootstrap";
import FormContainer from "../../../../containers/modules/warehouse/warehouse-in/form";
import FormContainerView from "../../../../containers/modules/warehouse/warehouse-in/form-view";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
export class WarehouseIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      chose : "",
      titleModal: "",
      listData: [],
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Transaction"), class: " text-gray-600" },
        { link: null, title: i18n.t("Warehouse In"), class: " text-gray-500" },
      ],

      column: [
        {
          key: "date_format",
          filter: { active: true, type: "Date", data: null },
          title: i18n.t("Date"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "doNo",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Document No."),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "receipt_no",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Receipt No."),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "createdAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "id",
          filter: {
            active: false,
          },
          title: i18n.t("Action"),
          type: "action",
          tHclass: "text-center min-w-150px",
          tdClass: "text-center",
          form:'icon',
          buttons: [
            {
              key: "id",
              btnText: i18n.t("View"),
              visible: {
                key: "status",
                key: "status",
                params: [1,2,0],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.viewData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Cancel"),
              visible: {
                key: "status",
                params: [1],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.cancelData(data);
              },
              bthClass: "btn btn-danger",
            },
            {
              key: "id",
              btnText: i18n.t("Print"),
              visible: {
                key: "status",
                params: [1, 2],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                return false;
              },
              btnLink:  "/warehouse/warehouse-in/print/",
              bthClass: "btn btn-warning",
            },
          ],
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.createData = this.createData.bind(this);
    this.cancelData = this.cancelData.bind(this);
    this.viewData = this.viewData.bind(this);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.chose = '1';
    this.state.titleModal = i18n.t("Add Warehouse In");
    this.props.createData();
  }
  updateData(id) {
    this.state.titleModal = i18n.t("Edit Warehouse In");
    this.props.updateItem(id);
  }
  viewData(id) {
    this.state.chose = '2';
    this.state.titleModal = i18n.t("Warehouse In");
    this.props.viewItem(id);
  }
  deleteData(id) {
    const html = (
      <>
        <div>{i18n.t("You will delete this Item")}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
        {i18n.t("Cancel")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  cancelData(id) {
    const html = (
      <>
        <div>{i18n.t("Cancel This Data")}</div>
        <Button variant="secondary" onClick={() => MySwal.close()}>
        {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            MySwal.fire({
              title: i18n.t("Enter your message"),
              icon: false,
              input: "text",
              inputValue: "",
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                if (!value) {
                  return i18n.t("You need to write something!");
                }
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const value = result.value;
                MySwal.fire({
                  title: i18n.t("Proccessing Data"),
                  html: "Please Wait ....",
                  icon: "info",
                });
                MySwal.showLoading();
                this.props.cancelItem(id, value, this.state.search);
              }
            });
          }}
        >
         {i18n.t("Accept")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }
  render() {
    const { isProcessing, data, showModal } = this.props;
    this.state.listData = data;
    return (
      <div id="WarehouseIn-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-WarehouseIns-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    // data-kt-WarehouseIn-table-toolbar="base"
                  >
                    <Button
                      type="button"
                      className="btn btn-warning m-1"
                      onClick={(e) => this.runSearch(this.state.search)}
                    >
                      <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-primary m-1"
                      onClick={(e) => this.createData()}
                    >
                      {i18n.t("Add Warehouse In")}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <Table
                  // checkAble={true}
                  numberAble={true}
                  expandAble={true}
                  theExpand={{
                    key: "warehouse_in_detail",
                    columns: [
                      { label: i18n.t("Item Code"), key: "code_item" },
                      { label: i18n.t("Item Name"), key: "name_item" },
                      { label: i18n.t("Banderol"), key: "bandNo" },
                      { label: i18n.t("Qty Received"), key: "qty_format" },
                      { label: i18n.t("Unit"), key: "name_unit" },
                      { label: i18n.t("Note"), key: "description" },
                    ],
                  }}
                  data={this.state.listData}
                  tools={false}
                  filterSearch={true}
                  column={this.state.column}
                  searchData={this.state.search}
                  runSearch={this.runSearch}
                  deleteData={this.deleteData}
                  updateData={this.updateData}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>
        {(this.state.chose == '1')?
        <FormContainer
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
        :
        <FormContainerView
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
        }
      </div>
    );
  }
}

export default WarehouseIn;
